import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Modal, ModalBody, Row } from 'reactstrap';
import Pagination from '../../Jobs/JobList2/Pagination';

import userImage1 from '../../../assets/images/yellofintunafish.png';
import cartImage from '../../../assets/images/Cart/image.png'

const OrderListing = ({ Orders }) => {
  console.log(Orders);
  // Delete Modal
  const [modal, setModal] = useState(false);

  const openModal = () => setModal(!modal);

  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          {Orders.map((order, key) => {
            const stockDetails = JSON.parse(order.stocks_details || '{}');
            const items = stockDetails.items || [];

            const total =
              Number(order.Courier_Fee) +
              Number(order.Processing_Fee) * Number(order.quantity) +
              Number(order.Price_per_Kg) * Number(order.quantity);

            return (
              <div>
                <div className="order-card">
      {/* Image */}
      <img
        src={cartImage} // Replace with actual image URL
        alt="Fishing Boat"
      />

      {/* Details */}
      <div className="details">
        <h2 style={{color:"black"}}>{order.Product_Name} ({order.quantity} Kg)</h2>
        <p className="fees">
          Stock Fee <span>LKR {order.Price_per_Kg.toLocaleString()}.00</span> | Processing Fee <span>LKR  {(
                                    order.Processing_Fee
                                  ).toLocaleString()}.00{' '}
                                  </span> |
          Courier Fee <span>LKR {order.Courier_Fee.toLocaleString()}.00</span>
        </p>
        <p className="price">LKR {total.toLocaleString()}.00</p>
         <div className="actions1">
        <button className="track-order">🛒 Track Order</button>
        <button className="more-details">More Details</button>
      </div>
      </div>

      {/* Actions */}
      <div className="actions2">
        <button className="track-order">🛒 Track Order</button>
        <button className="more-details">More Details</button>
      </div>
    </div>
                {/* <div
                  key={order._id}
                  className="list-item mt-3"
                >
                  <div
                    style={{ width: '100%' }}
                    className="card list-card"
                  >
                    <div
                      className="card-header"
                      style={{
                        background: '#eee',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <span style={{ fontSize: '0.9rem', fontWeight: '800' }}>
                        Stock {key + 1} of {Orders.length} ({order.Order_id})
                      </span>
                      <span
                        style={{
                          color: '#00d4ff',
                          fontSize: '0.9rem',
                          fontWeight: '800',
                        }}
                      >
                        {order.Status}
                      </span>
                    </div>

                    <div className="overlay-boat list-card-body card-body">
                      <div className="d-flex align-items-start">
                        <div
                          style={{
                            position: 'relative',
                            width: '25%',
                            height: '20%',
                          }}
                        >
                          <img
                            src={userImage1}
                            alt="Product"
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                            }}
                          />
                          <div
                            style={{
                              position: 'absolute',
                              top: '0',
                              left: '0',
                              width: '100%',
                              height: '100%',
                              backgroundColor: 'rgba(0, 0, 0, 0.5)', // Overlay color with opacity
                              color: 'white', // Text color
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              fontSize: '18px',
                            }}
                          ></div>
                        </div>
                        <div
                          style={{
                            position: 'absolute',
                            left: '10px',
                            top: '10px',
                          }}
                        ></div>
                        <div className="card-body-content flex-grow-1">
                          <div className="d-flex justify-content-between align-items-start">
                            <div style={{ minWidth: '300px' }}>
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  fontSize: '1.4rem',
                                  color: '#6c757d',
                                }}
                              >
                                <span style={{ fontWeight: '800' }}>
                                  {order.Product_Name}{' '}
                                </span>
                                <span style={{ fontWeight: '800' }}>
                                  {order.quantity} KG
                                </span>
                              </div>

                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  fontSize: '0.9rem',
                                  color: '#6c757d',
                                }}
                              >
                                <span style={{ fontWeight: '800' }}>
                                  Stock Fee{' '}
                                </span>
                                <span style={{ fontWeight: '800' }}>
                                  {(
                                    order.Price_per_Kg * order.quantity
                                  ).toLocaleString()}{' '}
                                  LKR
                                </span>
                              </div>

                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  fontSize: '0.9rem',
                                  color: '#6c757d',
                                }}
                              >
                                <span style={{ fontWeight: '800' }}>
                                  Processing Fee{' '}
                                </span>
                                <span style={{ fontWeight: '800' }}>
                                  {(
                                    order.Processing_Fee * order.quantity
                                  ).toLocaleString()}{' '}
                                  LKR
                                </span>
                              </div>

                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  fontSize: '0.9rem',
                                  color: '#6c757d',
                                }}
                              >
                                <span style={{ fontWeight: '800' }}>
                                  Courier Fee
                                </span>
                                <span style={{ fontWeight: '800' }}>
                                  {order.Courier_Fee.toLocaleString()} LKR
                                </span>
                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  fontSize: '1.2rem',
                                  color: '#6c757d',
                                }}
                              >
                                <span
                                  style={{
                                    fontWeight: '800',
                                    color: '#00d4ff',
                                  }}
                                >
                                  Total
                                </span>

                                <span
                                  style={{
                                    fontWeight: '800',
                                    color: '#00d4ff',
                                  }}
                                >
                                  {total.toLocaleString()} LKR
                                </span>
                              </div>

                            
                            </div>
                            <div
                              className="d-flex flex-column align-items-center p-2"
                              style={{ height: '100%' }}
                            >
                              <div className="mt-auto w-100 d-flex justify-content-between">
                                <Link
                                  to={`/ordertracking/${order._id}`}
                                  className="flex-grow-1 me-2"
                                >
                                  <button
                                    className="btn btn-success w-100"
                                    style={{
                                      padding: '0.5rem 1rem',
                                      fontSize: '0.9rem',
                                    }}
                                  >
                                    <i className="uli uil-location-arrow-alt fs-8 text-light"></i>{' '}
                                    Track
                                  </button>
                                </Link>
                                <Link
                                  to={`/orderdetails/${order._id}`}
                                  className="flex-grow-1"
                                >
                                  <button
                                    className="btn btn-info w-100"
                                    style={{
                                      padding: '0.5rem 1rem',
                                      fontSize: '0.9rem',
                                    }}
                                  >
                                    <i className="uil uil-info-circle fs-8 text-light"></i>{' '}
                                    More Details
                                  </button>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            );
          })}
        </Col>
      </Row>

      <div
        className="modal fade"
        id="deleteModal"
        tabIndex="-1"
        aria-labelledby="deleteModal"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <Modal
            isOpen={modal}
            toggle={openModal}
            centered
            tabIndex="-1"
          >
            <div className="modal-header">
              <h5
                className="modal-title"
                id="staticBackdropLabel"
              >
                Delete Order?
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <ModalBody>
              <div>
                <h6 className="text-danger">
                  <i className="uil uil-exclamation-triangle"></i> Warning: Are
                  you sure you want to delete this order?
                </h6>
                <p className="text-muted">
                  Your order will be permanently removed and you won't be able
                  to see it again.
                </p>
              </div>
            </ModalBody>
            <div className="modal-footer">
              <button
                type="button"
                onClick={openModal}
                className="btn btn-primary btn-sm"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-danger btn-sm"
              >
                Yes, delete
              </button>
            </div>
          </Modal>
        </div>
      </div>
    </React.Fragment>
  );
};

export default OrderListing;
